import Paginate, { PaginateData } from 'app/commons/components/Paginate';
import { storeComment, getComments } from 'app/requests/comments';
import { useSelector, useDispatch } from 'react-redux';
import * as commonActions from 'app/actions/commons';
import { toastError } from 'app/utils/toastHelper';
import React, { useState, useEffect } from 'react';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import CommentForm from './CommentForm';
import storage from 'app/utils/storage';
import { Message } from 'types/chat';

const CommentSection = ({ roomId }) => {
  const router = useRouter()
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [comments, setComments] = useState<Message[]>([]);
  const { auth } = useSelector((state: AppStoreState) => state.global);
  const [dataPaginate, setDataPaginate] = useState<PaginateData>();

  useEffect(() => {
    fetchComments();
  }, [page]);

  const fetchComments = async (newPage: number = 0) => {
    const result = await getComments(roomId, newPage || page);

    setDataPaginate({
      total: result.total,
      current_page: result.current_page,
      last_page: result.last_page,
    });
    setComments(result?.data);
  }

  const addComment = async (content: string, parent_message_id?: number) => {
    dispatch(commonActions.setLoading(true));
    try {
      await storeComment({ content, parent_message_id }, roomId);
      const newPage = parent_message_id ? 0 : 1;
      await fetchComments(newPage);
    } catch (error) {
      toastError(error.message);
    } finally {
      dispatch(commonActions.setLoading(false));
    }
  };

  const goToLogin = () => {
    storage.set("visitUrl", router.asPath);
    router.push('/auth/login');
  }

  return (
    <div className="comment-section">
      <hr />
      <div>
        <h2 className="text-info text-size-2xl mb-3">
          {t('comments.title')} ({dataPaginate?.total})
        </h2>
        {!auth?.id &&
          <div className="card p-3">
            <div className="d-flex align-items-center">
              <button
                type="button"
                className={`btn btn-info px-5 mx-auto`}
                onClick={() => goToLogin()}
              >
                {t('comments.login_to_comment')}
              </button>
            </div>
          </div>
        }
        <CommentForm
          onSubmit={(content: string, parentId: number) => addComment(content, parentId)}
          comments={comments}
          fetchComments={fetchComments}
          setComments={setComments}
        />
        {dataPaginate &&
          <Paginate
            data={dataPaginate}
            handleChangePage={(page: number) => setPage(page)}
          />
        }
      </div>
    </div>
  );
};

export default CommentSection;
